// extracted by mini-css-extract-plugin
module.exports = {"content":"EnrollementandRegisteration_content__24xLE","text":"EnrollementandRegisteration_text__3dHMD"};